import dayjs from "./dayjs";
import { toNumber } from "./format";

export function sortByDateDesc(items = [], key = "date") {
  return [...items].sort((a, b) => {
    const dateA = dayjs(a[key] || 0).valueOf();
    const dateB = dayjs(b[key] || 0).valueOf();
    return dateB - dateA;
  });
}

export function sumTransactions(items = []) {
  return items.reduce(
    (acc, item) => {
      const amount = toNumber(item.amount);

      if (item.type === "income") {
        acc.income += amount;
      } else {
        acc.expense += amount;
      }

      acc.net = acc.income - acc.expense;
      return acc;
    },
    { income: 0, expense: 0, net: 0 }
  );
}

export function filterTransactionsByRange(items = [], start, end) {
  return items.filter((item) => {
    if (!item.date) return false;
    const current = dayjs(item.date);

    if (start && current.isBefore(dayjs(start), "day")) return false;
    if (end && current.isAfter(dayjs(end), "day")) return false;

    return true;
  });
}

export function getRanges(now = dayjs()) {
  return {
    today: {
      start: now.startOf("day").format("YYYY-MM-DD"),
      end: now.endOf("day").format("YYYY-MM-DD")
    },
    week: {
      start: now.startOf("week").format("YYYY-MM-DD"),
      end: now.endOf("week").format("YYYY-MM-DD")
    },
    month: {
      start: now.startOf("month").format("YYYY-MM-DD"),
      end: now.endOf("month").format("YYYY-MM-DD")
    }
  };
}

export function buildDailyChartData(items = []) {
  const days = [...Array(7)].map((_, index) =>
    dayjs().subtract(6 - index, "day")
  );

  const labels = days.map((d) => d.format("DD/MM"));
  const income = [];
  const expense = [];

  days.forEach((day) => {
    const dayItems = items.filter((item) => dayjs(item.date).isSame(day, "day"));
    const sums = sumTransactions(dayItems);
    income.push(sums.income);
    expense.push(sums.expense);
  });

  return { labels, income, expense };
}

export function buildMonthlyNetChart(items = []) {
  const months = [...Array(6)].map((_, index) =>
    dayjs().subtract(5 - index, "month")
  );

  const labels = months.map((m) => m.format("MMM YYYY"));
  const values = months.map((month) => {
    const monthItems = items.filter((item) =>
      dayjs(item.date).isSame(month, "month")
    );
    return sumTransactions(monthItems).net;
  });

  return { labels, values };
}

export function calculateProjectProgress(tasks = []) {
  if (!tasks.length) return 0;
  const done = tasks.filter((item) => item.completed).length;
  return Math.round((done / tasks.length) * 100);
}

export function calculateProjectsOverview(projects = []) {
  return projects.reduce(
    (acc, project) => {
      acc.totalValue += toNumber(project.totalValue);
      acc.received += toNumber(project.receivedAmount);
      acc.remaining += toNumber(project.remainingAmount);
      if (project.status === "completed") acc.completed += 1;
      else acc.active += 1;
      return acc;
    },
    { totalValue: 0, received: 0, remaining: 0, completed: 0, active: 0 }
  );
}

export function buildPeriodRange(type, selectedDate) {
  const base = selectedDate ? dayjs(selectedDate) : dayjs();

  if (type === "day") {
    return {
      start: base.startOf("day").format("YYYY-MM-DD"),
      end: base.endOf("day").format("YYYY-MM-DD")
    };
  }

  if (type === "week") {
    return {
      start: base.startOf("week").format("YYYY-MM-DD"),
      end: base.endOf("week").format("YYYY-MM-DD")
    };
  }

  return {
    start: base.startOf("month").format("YYYY-MM-DD"),
    end: base.endOf("month").format("YYYY-MM-DD")
  };
}
